import { getLocale } from "../lib/utils";

export function timeAgo(date: Date, translate: any): string {
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 10) {
    return translate('now');
  }
  if (seconds < 60) {
    return `${seconds} sec${seconds !== 1 ? 's' : ''}`;
  }
  if (minutes < 60) {
    return `${minutes} min${minutes !== 1 ? 's' : ''}`;
  }
  if (hours < 24) {
    return `${hours}h`;
  }
  if (days === 1) {
    return translate('yesterday');
  }

  // Get last Monday (start of the week)
  const lastMonday = new Date(now);
  lastMonday.setDate(now.getDate() - now.getDay() - 6); // Go back to previous Monday
  lastMonday.setHours(0, 0, 0, 0);

  // Get yesterday's end
  const yesterdayEnd = new Date(now);
  yesterdayEnd.setDate(now.getDate() - 1);
  yesterdayEnd.setHours(23, 59, 59, 999);

  // If date is between last Monday and yesterday, show day name
  if (date >= lastMonday && date <= yesterdayEnd) {
    return date.toLocaleDateString(getLocale(), { weekday: 'long' });
  }

  // For dates older than last Monday, return the full date
  return date.toLocaleDateString(getLocale(), { day: 'numeric', month: 'short', year: 'numeric' });
}
